module.exports = __webpack_public_path__ + "img/jc1.b75b78ae.png";